import $api from "@http";

export default class AvatarService {
  static async getProxyList() {
    return $api.get("/proxy_list");
  }

  static async createScenarioSession({level, scenario_id}) {
    return $api.post("/api/v1/scenario_sessions", {level, scenario_id});
  }

  static async createProductSession({level, product_id}) {
    return $api.post("/api/v1/product_sessions", {level, product_id});
  }

  static async createCertificateSession({level, scenario_id, session_format}) {
    return $api.post("/api/v1/certification_scenario_sessions", {
      level,
      scenario_id,
      session_format,
    });
  }

  static async getQuestion({id}) {
    return $api.post(`/api/v1/product_sessions/${id}/question`);
  }

  static async sendAnswer({id, answer_id, answer}) {
    const prefix = document.body.getAttribute("data-ava-idle-request-prefix");

    if (!prefix) {
      return $api.post(`/api/v1/product_sessions/${id}/answer`, {
        answer_id,
        answer,
      });
    } else {
      return $api.post(`/${prefix}/api/v1/product_sessions/${id}/answer`, {
        answer_id,
        answer,
      });
    }
  }

  static async sendMessage({id, msg}) {
    const prefix = document.body.getAttribute("data-ava-idle-request-prefix");

    if (!prefix) {
      return $api.post(`/api/v1/scenario_sessions/${id}/message`, {
        id,
        msg,
      });
    } else {
      return $api.post(`/${prefix}/api/v1/scenario_sessions/${id}/message`, {
        id,
        msg,
      });
    }
  }

  static async sendCertificateMessage({id, msg}) {
    return $api.post(`/api/v1/certification_scenario_sessions/${id}/message`, {
      id,
      msg,
    });
  }

  static async getScenarioFeedback(id) {
    return $api.post(`/api/v1/scenario_sessions/${id}/feedback`);
  }

  static async getCertificateFeedback(id) {
    return $api.post(`/api/v1/certification_scenario_sessions/${id}/feedback`);
  }

  static async getProductFeedback(id) {
    return $api.post(`/api/v1/product_sessions/${id}/feedback`);
  }

  static async getSummarizingFeedback(
    source_type,
    product_id,
    scenario_ids,
    target_user_id,
    start_date,
    end_date,
  ) {
    const requestBody = {
      source_type,
      target_user_id,
      start_date,
      end_date,
    };

    if (source_type === "product") {
      requestBody.product_id = product_id;
    } else {
      requestBody.scenario_ids = scenario_ids;
    }

    return $api.post(`/api/v1/summarizations`, requestBody);
  }

  static async getSummarizingFeedbackId(id) {
    return $api.get(`/api/v1/summarizations/${id}`);
  }

  static async getSummarizingFeedbackHistory(id, page, size) {
    return $api.get(
      `/api/v1/users/${id}/summarizations?page=${page}&page_size=${size}`,
    );
  }

  static async removeSummarizingFeedback(id) {
    return $api.delete(`/api/v1/summarizations/${id}`);
  }

  static async getRecordToken() {
    return $api.post(`/stt_jwt`);
  }

  static async getAvatarToken(payload = {}) {
    return $api.post(`/live_avatar_token`, payload);
  }

  static async getAnamAiToken(payload = {}) {
    return $api.post(`/anam_ai_token`, payload);
  }

  static async getAkoolToken() {
    return $api.post(`/akool_token`);
  }
}
